import { useMemo, useState } from "react";
import { getLocalEvents, loadState } from "../lib/storage";

type RemoteSession = {
  id: string;
  participant_code: string;
  stage: string;
  block_number: number;
  updated_at: string;
  state_json: string;
};

export function AdminPage() {
  const [password, setPassword] = useState("");
  const [sessions, setSessions] = useState<RemoteSession[]>([]);
  const [status, setStatus] = useState<"idle" | "loading" | "ready" | "error">("idle");
  const localState = useMemo(() => loadState(), []);
  const localEvents = useMemo(() => getLocalEvents(), []);

  const loadRemote = async () => {
    setStatus("loading");
    try {
      const token = btoa(`admin:${password}`);
      const response = await fetch("/api/admin/results", { headers: { authorization: `Basic ${token}` } });
      if (!response.ok) throw new Error("admin-request-failed");
      const data = (await response.json()) as { sessions: RemoteSession[] };
      setSessions(data.sessions);
      setStatus("ready");
    } catch {
      setStatus("error");
    }
  };

  return (
    <main className="admin-page">
      <header className="admin-heading">
        <div><p className="eyebrow">TEST ADMIN</p><h1>本実験プロトタイプ 管理画面</h1><p>テスト環境の保存状況と進行状態を確認します。</p></div>
        <a className="secondary-button" href="/">参加者画面へ戻る</a>
      </header>

      <section className="metric-grid">
        <article><span>このブラウザ</span><strong>{localState ? "1" : "0"}</strong><small>保存セッション</small></article>
        <article><span>操作イベント</span><strong>{localEvents.length}</strong><small>このブラウザ内</small></article>
        <article><span>完了試行</span><strong>{localState?.trials.length ?? 0}</strong><small>3試行中</small></article>
      </section>

      <section className="admin-panel">
        <div className="panel-heading"><div><h2>D1に保存されたテスト結果</h2><p>デプロイ後は環境変数で設定した管理パスワードを入力します。</p></div><div className="admin-login"><input type="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="テスト管理パスワード" /><button className="primary-button" type="button" onClick={loadRemote}>読み込む</button></div></div>
        {status === "error" && <p className="error-message">読み込めませんでした。ローカル開発時はD1 APIが動作していない場合があります。</p>}
        <div className="admin-table-wrap">
          <table className="admin-table"><thead><tr><th>実験ID</th><th>段階</th><th>試行</th><th>最終保存</th></tr></thead><tbody>
            {sessions.length > 0 ? sessions.map((session) => <tr key={session.id}><td>{session.participant_code}</td><td>{session.stage}</td><td>{Math.min(session.block_number + 1, 3)} / 3</td><td>{new Date(session.updated_at).toLocaleString("ja-JP")}</td></tr>) : <tr><td colSpan={4}>D1の結果はまだ読み込まれていません。</td></tr>}
          </tbody></table>
        </div>
      </section>

      <section className="admin-panel">
        <div className="panel-heading"><div><h2>このブラウザの保存内容</h2><p>APIが未設定でも、プロトタイプ確認用に端末内へ保存します。</p></div></div>
        <pre className="state-preview">{localState ? JSON.stringify(localState, null, 2) : "保存された状態はありません。"}</pre>
      </section>
    </main>
  );
}
